import { render, staticRenderFns } from "./TextFieldOnInput.vue?vue&type=template&id=572a4c12&"
import script from "./TextFieldOnInput.vue?vue&type=script&lang=ts&"
export * from "./TextFieldOnInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports